export default __webpack_public_path__ + "static/media/moru-sravani.e244ebac.png";